import { Chat } from "@/components/Chat";
import { Header } from "@/components/Header";

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-rose-50">
      <Header />
      <div className="pt-16">
        <Chat />
      </div>
    </div>
  );
};

export default Index;